import BaseModelAPI from '../BaseModelAPI';

export default class PickingSupplyForProductionCase extends BaseModelAPI {
	static entity = 'pickingsupplyforproductioncase';
	static entityName = 'pickingsupplyforproductioncase';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.pickingSupplyForProductionId = '';
			this.pickingSupplyForProduction = {};
			this.pickingSupplyForProductionDetailId = '';
			this.pickingSupplyForProductionDetail = {};
			this.controlCardId = '';
			this.controlCard = {};
			this.partId = '';
			this.part = {};
			this.qty = 0;
			this.remark = '';
			this.documentStatusId = '';
			this.documentStatus = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}